import { REQUEST_PROTECTION_PLAN_BUSINESS, RECEIVE_PROTECTION_PLAN_BUSINESS, IProtectionPlanBusinessState, ProtectionPlanTypes } from "./types";

const initialState: IProtectionPlanBusinessState = { protectionPlanData: {}, isLoading: false };

export function protectionPlanReducer(state = initialState, action: ProtectionPlanTypes): IProtectionPlanBusinessState {
    if (state === undefined) {
        return initialState;
    }

    switch (action.type) {
        case REQUEST_PROTECTION_PLAN_BUSINESS:
            return {
                isLoading: true,
                protectionPlanData: state.protectionPlanData,
            };
        case RECEIVE_PROTECTION_PLAN_BUSINESS:
            return {
                isLoading: false,
                protectionPlanData: action.protectionPlanData,
            };
        default:
            return state;
    }
}
